import React, { useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import "ag-grid-community/styles/ag-theme-alpine.css";
import * as XLSX from "xlsx";

ModuleRegistry.registerModules([AllCommunityModule]);
const TableComponent = ({ data, columns }) => {
  const [gridApi, setGridApi] = useState(null);
  const [columnApi, setColumnApi] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    setFilteredData(data || []);
  }, [data]);

  useEffect(() => {
    if (columnApi) {
      const allColumns = columnApi.getAllColumns();
      if (allColumns) {
        columnApi.setColumnWidths(
          allColumns.map((col) => ({ key: col.getColId(), newWidth: 140 }))
        );
      }
    }
  }, [filteredData, columnApi]); // Also include `columnApi` in dependencies

  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchText(searchValue);

    const newFilteredData = data.filter((row) =>
      columns.some((col) => {
        const cellValue = row[col.field]
          ? row[col.field].toString().toLowerCase()
          : "";
        return cellValue.includes(searchValue);
      })
    );

    setFilteredData(newFilteredData);
  };

  const exportExcel = () => {
    const visibleColumns = columns.filter((col) => col.field !== "action");
    const selectedNodes = gridApi.getSelectedNodes();
    const exportData = selectedNodes.length
      ? selectedNodes.map((node) => node.data)
      : filteredData;

    const formattedData = exportData.map((row) =>
      Object.fromEntries(
        visibleColumns.map((col) => [col.headerName, row[col.field]])
      )
    );

    const ws = XLSX.utils.json_to_sheet(formattedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "table.xlsx");
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);

    if (params.columnApi) {
      setTimeout(() => {
        const allColumns = params.columnApi.getAllColumns();
        if (allColumns) {
          params.columnApi.autoSizeColumns(
            allColumns.map((col) => col.getId()),
            false
          );
        }
      }, 100); // Delay execution to ensure columnApi is ready
    }
  };

  const onFirstDataRendered = (params) => {
    params.api.sizeColumnsToFit();
    setTimeout(() => {
      if (columnApi) {
        const allColumns = columnApi.getAllColumns();
        columnApi.autoSizeColumns(
          allColumns.map((col) => col.getId()),
          false
        );
      }
    }, 100);
  };

  return (
    <div className="ag-theme-alpine" style={{ width: "100%", height: "auto" }}>
      <div style={{ marginBottom: 10, display: "flex", gap: "10px" }}>
        <button
          className="btn btn-outline-success btn-sm"
          onClick={exportExcel}
        >
          Export Excel
        </button>
        <button className="btn btn-outline-danger btn-sm">Export PDF</button>
        <input
          type="text"
          className="form-control"
          placeholder="Search..."
          value={searchText}
          onChange={handleSearch}
          style={{ maxWidth: "300px" }}
        />
      </div>

      {filteredData.length > 0 ? (
        <AgGridReact
          domLayout="autoHeight"
          columnDefs={columns}
          rowData={filteredData}
          rowSelection={{ mode: "multiRow" }}
          pagination={true}
          defaultColDef={{
            sortable: true,
            filter: "agTextColumnFilter",
            resizable: true,
            minWidth: 120,
          }}
          onGridReady={onGridReady}
          onFirstDataRendered={onFirstDataRendered}
        />
      ) : (
        <p style={{ textAlign: "center", marginTop: "20px", color: "gray" }}>
          No data available
        </p>
      )}
    </div>
  );
};

export default TableComponent;
